#version 300 es
    
precision highp float;

in vec2 position;
in vec3 textureCoords;

out vec3 pass_textureCoordinates;

void main(){
    
    gl_Position = vec4(position, 0.0, 1.0);
    
    pass_textureCoordinates = textureCoords;
}